// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#loading-infos[data-v-8e641832]{min-width:100px}", ""]);
// Exports
module.exports = exports;
